import React, { FC, ReactNode } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

interface BlockNodeToolbarProps {
  onDelete: () => void;
  deleteTooltip: string;
  onEdit?: () => void;
  editTooltip?: string;
  extraButtons?: ReactNode;
}

export const BlockNodeToolbar: FC<BlockNodeToolbarProps> = ({ onDelete, deleteTooltip, onEdit, editTooltip, extraButtons }) => {
  return (
    <Stack direction="row" alignItems="center">
      {extraButtons}
      {onEdit && (
        <Tooltip title={editTooltip ?? 'Rediger'}>
          <IconButton tabIndex={-1} onClick={onEdit}>
            <Edit />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={deleteTooltip}>
        <IconButton tabIndex={-1} onClick={onDelete}>
          <Delete />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
